import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDetailResponseDTO,
	type ClientPortfolioNonLifeInsuranceEditRequestDTO,
	patchPortfolioNonLifeInsuranceIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioNonLifeInsuranceMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioNonLifeInsuranceEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioNonLifeInsuranceIdV2(requestContract, id),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioDetail(id),
			});
		},
	});
};
